import React, { useEffect, useState } from "react";

import {
    Card,
    Row,
    Col,
    Select,
    Button,
    Table,
    Typography,
    Space,
    message,
    Spin,
    Empty,
    Tag
} from "antd";


import {
    SafetyCertificateOutlined,
    DownloadOutlined,
    TeamOutlined
} from "@ant-design/icons";


import api from "../../api/api";

import { useAcademicYear } from "../../AcademicYearContext";

import GraduateCertificatePDF from "./GraduateCertificatePDF";

import "./CertificateDashboard.css";



const {
    Title,
    Text
} = Typography;


const {
    Option
} = Select;





/*
================================================
HELPERS
================================================
*/


const getDisplayValue = (value) => {


    if (!value) {

        return "";

    }


    if (typeof value === "object") {


        return (
            value.name ||
            value.title ||
            ""
        );


    }


    return value;

};






const getGradeClassLabel = (item) => {


    const className =
        getDisplayValue(item?.name);



    const division =
        getDisplayValue(item?.division);




    if (division) {


        return `${className} - ${division}`;


    }



    return className;



};









const CertificateDashboard = () => {



    const {
        selectedYear
    } = useAcademicYear();





    const [gradeClasses,setGradeClasses] =
        useState([]);



    const [selectedClass,setSelectedClass] =
        useState(null);



    const [students,setStudents] =
        useState([]);




    const [selectedStudent,setSelectedStudent] =
        useState(null);




    const [certificates,setCertificates] =
        useState([]);




    const [loading,setLoading] =
        useState(false);




    const [studentLoading,setStudentLoading] =
        useState(false);









    /*
    ================================================
    FETCH GRADE CLASSES
    ================================================
    */


    const fetchGradeClasses = async()=>{


        try{


            const response =
                await api.get(
                    "/api/users/grade-classes/"
                );



            const data =

                response.data.results ||

                response.data ||

                [];



            setGradeClasses(data);



        }
        catch(error){


            console.log(error);



            message.error(
                "Unable to load grade classes"
            );


        }


    };









    /*
    ================================================
    FETCH CERTIFICATE HISTORY
    ================================================
    */


    const fetchCertificates = async()=>{


        try{


            setLoading(true);



            const response =
                await api.get(
                    "/certificates/",
                    {
                        params:{
                            academic_year:
                            selectedYear?.id
                        }
                    }
                );



            setCertificates(

                response.data.results ||

                response.data ||

                []

            );



        }
        catch(error){


            console.log(error);


            message.error(
                "Unable to load certificates"
            );


        }
        finally{


            setLoading(false);


        }


    };









    /*
    ================================================
    FETCH GRADUATED STUDENTS
    ================================================
    */


    const fetchStudents = async(classId)=>{


        if(!classId){


            setStudents([]);


            return;


        }





        try{


            setStudentLoading(true);



            const response =

                await api.get(

                    "graduated-students/",

                    {
                        params:{

                            grade_class:
                            classId,


                            academic_year:
                            selectedYear?.id

                        }
                    }

                );





            setStudents(

                response.data.results ||

                response.data ||

                []

            );



        }
        catch(error){


            console.log(error);



            message.error(
                "Unable to load graduated students"
            );


        }
        finally{


            setStudentLoading(false);


        }


    };









    useEffect(()=>{


        fetchGradeClasses();


    },[]);







    useEffect(()=>{


        if(selectedYear){

            fetchCertificates();

        }


    },[selectedYear]);









    /*
    ================================================
    CLASS CHANGE
    ================================================
    */


    const handleClassChange = (classId)=>{


        const selected =

            gradeClasses.find(

                item =>
                item.id === classId

            );



        setSelectedClass(selected);



        setSelectedStudent(null);



        fetchStudents(classId);



    };












    /*
    ================================================
    GENERATE SINGLE CERTIFICATE
    ================================================
    */


    const generateStudentCertificate = ()=>{


        if(!selectedClass){


            message.warning(
                "Please select grade class"
            );


            return;


        }




        if(!selectedStudent){


            message.warning(
                "Please select student"
            );


            return;


        }




        const student =

            students.find(

                item =>
                item.id === selectedStudent

            );




        if(!student){


            message.error(
                "Student not found"
            );


            return;


        }




        GraduateCertificatePDF.downloadSingle(

            student,

            selectedClass,

            selectedYear

        );


    };












    /*
    ================================================
    GENERATE ALL CERTIFICATES
    ================================================
    */


    const generateClassCertificates = ()=>{


        if(!selectedClass){


            message.warning(
                "Please select grade class"
            );


            return;


        }



        if(students.length===0){


            message.warning(
                "No graduated students found"
            );


            return;


        }





        GraduateCertificatePDF.downloadMultiple(

            students,

            selectedClass,

            selectedYear

        );


    };














    /*
    ================================================
    TABLE
    ================================================
    */


    const columns = [



        {


            title:"Student Name",

            key:"student_name",


            render:(_,record)=>{


                return (

                    record.student_name ||

                    record.full_name ||

                    getDisplayValue(record.name) ||

                    "-"

                );


            }


        },






        {


            title:"Grade Class",

            key:"grade_class",


            render:(_,record)=>{


                if(record.grade_class_name){

                    return record.grade_class_name;

                }



                if(record.grade_class){

                    return getGradeClassLabel(
                        record.grade_class
                    );

                }



                return "-";


            }


        },







        {


            title:"Academic Year",

            key:"academic_year",


            render:(_,record)=>{


                if(record.academic_year_name){

                    return record.academic_year_name;

                }



                if(record.academic_year){


                    return getDisplayValue(
                        record.academic_year
                    );


                }



                return "-";


            }


        },







        {


            title:"Generated Date",

            dataIndex:"created_at",


            render:(date)=>{


                if(!date){

                    return "-";

                }


                return new Date(date)
                    .toLocaleDateString();


            }


        },







        {


            title:"Status",

            key:"status",


            render:()=>(
                <Tag color="green">
                    Generated
                </Tag>
            )


        }



    ];

return (
  <div className="certificate-dashboard">
     <Row gutter={[20,20]}>
       <Col xs={24}>
          <Card className="certificate-header">


<Space direction="vertical">
<Title level={2}>
<SafetyCertificateOutlined/>
{" "}
Graduation Certificate Dashboard
</Title>

<Text type="secondary">
Generate professional graduation certificates for graduated students.
</Text>
</Space>
</Card>
</Col>

 <Col xs={24} lg={8}>

<Card title="Certificate Generator">
<Space
direction="vertical" size="large"
style={{ width:"100%" }}>

<Select
style={{
width:"100%"
}}
placeholder="Select Grade Class"
value={
selectedClass?.id
}
onChange={
handleClassChange
}
showSearch
optionFilterProp="children"
>
{
gradeClasses.map(item=>(

<Option
key={item.id}
value={item.id}
>
{getGradeClassLabel(item)}
</Option>
))
}
</Select>



<Select
style={{ width:"100%" }}
placeholder="Select Graduated Student"
value={
selectedStudent
}
loading={
studentLoading
}
disabled={
!selectedClass
}
onChange={
setSelectedStudent
}
showSearch
optionFilterProp="children"
>
{
students.map(student=>(

<Option
key={student.id}
value={student.id}
>
{
student.full_name ||
getDisplayValue(student.name)
}
</Option>
))
}
</Select>

<Button
type="primary"
block
icon={
<DownloadOutlined/>
}
onClick={
generateStudentCertificate
}
>
Generate Student Certificate
</Button>


<Button
block
icon={
<TeamOutlined/>
}
onClick={
generateClassCertificates
}
>
Generate All Graduate Certificates
</Button>





                        </Space>


                    </Card>


                </Col>









                <Col xs={24} lg={16}>


                    <Card title="Certificate History">


{

loading ?

<Spin/>

:

<Table

columns={columns}

dataSource={certificates}

rowKey="id"

pagination={{
pageSize:10
}}

locale={{
emptyText:<Empty/>
}}

/>


}



                    </Card>


                </Col>






            </Row>


        </div>


    );


};





export default CertificateDashboard;